<template>
    <div
        :class="{ 'ask-pendo-context-button-wrapper--icon-only': iconOnly }"
        @mouseenter="isButtonHovered = true"
        @mouseleave="isButtonHovered = false">
        <pendo-button
            v-if="!iconOnly"
            class="ask-pendo-context-button"
            theme="app"
            type="secondary"
            :label="isLeoRebrand ? $t('askPendo.Ask Leo') : $t('askPendo.Ask agent mode')"
            :disabled="disabled"
            pendo-feature="ask-pendo-context-button"
            @click="openConversationDrawer">
            <leo-sparkle-icon
                circle-hidden
                :spinning="!disabled && isButtonHovered" />
            <span>{{ isLeoRebrand ? $t('askPendo.Ask Leo') : $t('askPendo.Ask agent mode') }}</span>
        </pendo-button>
        <pendo-button
            v-else
            v-pendo-tooltip="{ content: isLeoRebrand ? $t('askPendo.Ask Leo') : $t('askPendo.Ask agent mode'), offset: 4 }"
            class="ask-pendo-context-button--icon-only"
            theme="app"
            type="tertiary"
            :disabled="disabled"
            :aria-label="isLeoRebrand ? $t('askPendo.Ask Leo') : $t('askPendo.Ask agent mode')"
            pendo-feature="ask-pendo-context-button"
            @click="openConversationDrawer">
            <leo-sparkle-icon :spinning="!disabled && isButtonHovered" />
        </pendo-button>
    </div>
</template>
<script>
import { PendoButton, PendoTooltip } from '@pendo/components';
import LeoSparkleIcon from '@/ask-pendo/components/leo-sparkle-icon.vue';
import { mapActions } from 'vuex';
import { v4 as uuid } from 'uuid';
import { openAgentModePanel } from '@/vue-router/agent-mode-panel-url.utils';

export default {
    name: 'AskPendoContextButton',
    components: {
        LeoSparkleIcon,
        PendoButton,
    },
    directives: {
        PendoTooltip,
    },
    props: {
        /**
         * Metadata describing the context in which the conversation is taking place.
         */
        context: {
            type: Object,
            default: () => ({}),
        },
        suggestedQuestions: {
            type: Array,
            default: () => [],
        },
        iconOnly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        /** When provided, called on click to get conversation id instead of creating with prompt. Enables custom flows (e.g. table artifact). */
        getConversationId: {
            type: Function,
            default: null,
        },
    },
    data () {
        return {
            isButtonHovered: false,
        };
    },
    computed: {
        isLeoRebrand () {
            return this.$segmentFlag('leoRebrand');
        },
    },
    methods: {
        ...mapActions('askPendo', ['createConversation']),
        async openConversationDrawer () {
            let conversationId;
            if (this.getConversationId) {
                conversationId = await this.getConversationId();
            } else {
                conversationId = uuid();
                await this.createConversation({
                    id: conversationId,
                    user_context: {
                        ...this.context,
                        suggestedQuestions: this.suggestedQuestions,
                    },
                });
            }

            if (conversationId) {
                openAgentModePanel(this.$router, this.$route, conversationId, {
                    paramKey: this.isLeoRebrand ? 'leo' : 'agent-mode',
                });
            }
        },
    },
};
</script>

<style scoped lang="less">
.ask-pendo-context-button {
    color: var(--palette-gray-100);
    border: 1px solid transparent;
    border-radius: 3px; /* Works with border-radius */
    background:
        linear-gradient(var(--palette-gray-0), var(--palette-gray-0)) padding-box,
        linear-gradient(to right, var(--palette-purple-70), var(--palette-teal-60)) border-box;
    background-origin: border-box;
    background-clip: padding-box, border-box;
    transition: box-shadow 0.25s ease;

    :deep(> span) {
        display: inline-flex;
        align-items: center;
        gap: 4px;
    }

    &:hover {
        color: var(--palette-gray-100);
        border: 1px solid transparent;
        box-shadow: 0 4px 8px 0 rgba(var(--raw-palette-gray-100), 0.17);
    }
}

.ask-pendo-context-button-wrapper--icon-only {
    display: flex;
    align-items: center;
}

.ask-pendo-context-button--icon-only {
    height: 24px;
    min-width: 24px;
    line-height: 24px;
    border-radius: 100%;
    transition: box-shadow 0.25s ease;

    &:hover {
        box-shadow: 0 2px 4px 0 rgba(var(--raw-palette-gray-100), 0.17);
    }
}
</style>
